import { useState } from 'react';
import type { StateResponseAPI } from '../../types/states';
import AnomalyDashboard from '../anomalyDetection/AnomalyDashboard';
import { AnomalyDashboardProvider } from '../anomalyDetection/AnomalyProvider';
import ScreenRouter from '../generic/ScreenRouter';
import { InsightsProvider } from './InsightsProvider';
import './developer-dashboard.less';
import ConnectorInvokerRequestInsights from './insightsDetailed/ConnectorInvokerRequestInsights';
import ErrorsInsights from './insightsDetailed/ErrorsInsights';
import StatesInsights from './insightsDetailed/StatesInsights';
import UsageInsights from './insightsDetailed/UsageInsights';
import InsightsSummary from './insightsSummary/InsightsSummary';

export enum View {
    summary = 'summary',
    usage = 'usage',
    anomaly = 'anomaly',
    error = 'error',
    states = 'states',
    connectorInvokerRequests = 'connectorInvokerRequests',
}

export type SelectedFlow = {
    id: string;
    name: string;
};

const InsightsDashboard = () => {
    const [currentView, setCurrentView] = useState<View>(View.summary);
    const [selectedFlow, setSelectedFlow] = useState<SelectedFlow>({ id: '', name: '' });
    const [stateDetails, setStateDetails] = useState<StateResponseAPI | null>(null);

    return (
        <div className="admin-page">
            <AnomalyDashboardProvider initialDateIndex={0}>
                <InsightsProvider>
                    <ScreenRouter currentScreen={currentView}>
                        <InsightsSummary screen={View.summary} setCurrentView={setCurrentView} />
                        <UsageInsights
                            screen={View.usage}
                            setCurrentView={(view: View, selectedFlow: SelectedFlow) => {
                                setCurrentView(view);
                                setSelectedFlow(selectedFlow);
                            }}
                        />
                        <AnomalyDashboard screen={View.anomaly} setCurrentView={setCurrentView} />
                        <ErrorsInsights screen={View.error} setCurrentView={setCurrentView} />
                        <StatesInsights
                            screen={View.states}
                            setCurrentView={setCurrentView}
                            selectedFlow={selectedFlow}
                            setStateDetails={setStateDetails}
                        />
                        <ConnectorInvokerRequestInsights
                            screen={View.connectorInvokerRequests}
                            selectedFlow={selectedFlow}
                            stateDetails={stateDetails}
                            setStateDetails={setStateDetails}
                            setCurrentView={setCurrentView}
                            setSelectedFlow={setSelectedFlow}
                        />
                    </ScreenRouter>
                </InsightsProvider>
            </AnomalyDashboardProvider>
        </div>
    );
};

export default InsightsDashboard;
